import createIcon from '../../createIcon';

/**
 * @component @name DownloadForOffline
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkM2LjQ5IDIgMiA2LjQ5IDIgMTJDMiAxNy41MSA2LjQ5IDIyIDEyIDIyQzE3LjUxIDIyIDIyIDE3LjUxIDIyIDEyQzIyIDYuNDkgMTcuNTEgMiAxMiAyWk0xMiAyMEM3LjU5IDIwIDQgMTYuNDEgNCAxMkM0IDcuNTkgNy41OSA0IDEyIDRDMTYuNDEgNCAyMCA3LjU5IDIwIDEyQzIwIDE2LjQxIDE2LjQxIDIwIDEyIDIwWk0xNC41OSA4LjU5TDE2IDEwTDEyIDE0TDggMTBMOS40MSA4LjU5TDExIDEwLjE3VjZIMTNWMTAuMTdMMTQuNTkgOC41OVpNMTcgMTdIN1YxNUgxN1YxN1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DownloadForOffline = createIcon('DownloadForOffline', [
  [
    'path',
    {
      d: 'M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM14.59 8.59L16 10L12 14L8 10L9.41 8.59L11 10.17V6H13V10.17L14.59 8.59ZM17 17H7V15H17V17Z',
      key: '1hui8f',
    },
  ],
]);

export default DownloadForOffline;
